import { render, staticRenderFns } from "./PasoCompraParcelasOnline.vue?vue&type=template&id=74a66128"
import script from "./PasoCompraParcelasOnline.vue?vue&type=script&lang=js"
export * from "./PasoCompraParcelasOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports